export function highlightText(input) {
  if (!input || typeof input !== "string") {
    console.error("Input is not a string or is null");
    return input;
  }
  // Replace all words between asterisks with <b> tag
  return input.replace(/\*([^*]+)\*/g, "<b>$1</b>");
}
